
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gqcwpfeippxdygrcyovc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdxY3dwZmVpcHB4ZHlncmN5b3ZjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk0MTUzODksImV4cCI6MjA2NDk5MTM4OX0.uDKpDTMBPzMirD4WuULtouvQgaXNeA8go6Jt7fHoP0U";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'estancia-corta-auth',
    // 7 días de expiración para el token de refresh
    flowType: 'pkce'
  },
  global: {
    headers: {
      'X-Client-Info': 'estancia-corta@1.0.0'
    }
  }
});
